<template>
  <address-blank-form
    submit-label="Сохранить"
    v-bind="$attrs"
    form-type="edit"
    :errors="errors"
    @submit="processAddressForm"
  />
</template>

<script>
import helpers from '@/helpers'
import { updateAddress } from '@/services/address.service'
import addressBlankForm from '@/components/forms/address/AddressBlankForm'

export default {
  name: 'address-edit-form',
  components: { addressBlankForm },
  inheritAttrs: false,
  data () {
    return {
      errors: {
        address: {
          id: [],
          name: [],
          district: []
        },
        non_field_errors: []
      }
    }
  },
  methods: {
    fillErrors: helpers.fillErrors,

    processAddressForm () {
      this.updateAddress().then((success) => {
        if (success) {
          this.showMsg('Информация об адресе была успешно обновлена!', 'success', 'Успешно')
          this.$emit('after', true)
        } else {
          this.$emit('after', false)
        }
      })
    },
    updateAddress () {
      return updateAddress(this.$attrs.address).then((response) => {
        this.fillErrors(this.errors.address, {})
        return true
      }).catch(err => {
        this.fillErrors(this.errors.address, err.response.data)

        if (this.errors.non_field_errors[0]) {
          this.$parent.$parent.showPopupMsg(this.errors.non_field_errors[0], 'error')
        }

        return false
      })
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// AddressEditForm.vue?72ce66ec